<template>
  <v-navigation-drawer
    app
    width="250"
    clipped
    v-model="showLeftMenuFromBar"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title
          class="text-h6 mb-5"
          style="display: flex; justify-content: space-between"
        >
          <p class="mb-0">Páginas</p>
          <v-icon @click="createPage">mdi-plus</v-icon>
        </v-list-item-title>

        <!-- Lista de páginas-->
        <v-list-item-group
          v-model="retrievedSelectedPage"
          color="primary"
          mandatory
          style="display: flex; flex-direction: column; justify-content: space-between; width: 100%"
        >
          <v-list-item
            v-for="(page, index) in activePages()"
            :key="index"
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <p class="mb-0">{{ page.name }}</p>
            <v-icon v-if="page.main">mdi-home</v-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="text-h6"> Herramientas </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-2"></v-divider>

    <!-- LISTA DE HERRAMIENTAS -->
    <v-btn
      class="ma-2"
      @click="createItem(current_tool)"
      v-for="(current_tool, index_tool) in tools"
      :key="index_tool"
      :title="current_tool.toolbar.name"
    >
      <img
        class="tool"
        :src="require(`@/${current_tool.root}/${current_tool.toolbar.path}`)"
      />
    </v-btn>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(["pages", "selectedPage", "showLeftMenu"]),

    showLeftMenuFromBar: {
      get() {
        return this.showLeftMenu;
      },
      set(value) {
        this.toggleLeftMenu(value);
      },
    },

    retrievedSelectedPage: {
      get() {
        return this.selectedPage;
      },
      set(value) {
        this.setSelectedPage(value);
      },
    },
  },

  props: {
    tools: Array,
  },

  methods: {
    ...mapGetters(["activePages"]),
    ...mapMutations(["setSelectedPage", "toggleLeftMenu"]),
    ...mapActions(["addItem", "addPage"]),

    createItem(item) {
      this.addItem(item);
    },

    createPageName() {
      if (this.activePages().length != 0) {
        const pageNumbers = this.pages
          .filter((page) => page.name.startsWith("Página"))
          .map((page) => parseInt(page.name.replace("Página ", "")));
        const pageNumber = Math.max(...pageNumbers);
        if (pageNumber != -Infinity) {
          return "Página " + (pageNumber + 1);
        }
      }
      return "Página 1";
    },

    createPage() {
      const newPage = {
        name: this.createPageName(),
        item_list: [],
        global_item_list: [],
        background_image: null,
        z_index: 0,
        main: this.pages.length == 0,
        active: true,
      };
      this.addPage(newPage);
    },
  },
};
</script>

<style>
.tool {
  height: 32px;
  width: 32px;
  display: block;
  resize: both;
}
</style>